import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const pmoRoutes = [
	{
		key: "pmo-portfolio",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/portfolio`,
		component: React.lazy(() => import("views/app-views/pmo/pages/PortfolioList")),
	},
	{
		key: "pmo-project",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/project`,
		component: React.lazy(() => import("views/app-views/pmo/pages/Projects")),
	},
	{
		key: "pmo-project-view",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/project/:id`,
		component: React.lazy(() => import("views/app-views/pmo/pages/ProjectView")),
	},
	{
		key: "pmo-my-tasks",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/tasks`,
		component: React.lazy(() => import("views/app-views/pmo/pages/MyTasks")),
	},
	{
		key: "pmo-portfolio-budget",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/portfolio/budget`,
		component: React.lazy(() => import("views/app-views/pmo/pages/BudgetPlan")),
	},
	{
		key: "pmo-allocation-estimates",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/estimates`,
		component: React.lazy(() => import("views/app-views/pmo/pages/AllocationEstimates")),
	},
	{
		key: "pmo-requests",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/requests`,
		component: React.lazy(() => import("views/app-views/pmo/pages/RequestList")),
	},
	{
		key: "pmo-customer",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/customer`,
		component: React.lazy(() => import("views/app-views/pmo/pages/CustomerList")),
	},
	{
		key: "pmo-invoice",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/invoice`,
		component: React.lazy(() => import("views/app-views/pmo/pages/InvoiceList")),
	},
	{
		key: "pmo-invoice-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/invoice/create`,
		component: React.lazy(() => import("views/app-views/pmo/pages/InvoiceCreate")),
	},
	{
		key: "pmo-invoice-edit",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/invoice/edit/:id`,
		component: React.lazy(() => import("views/app-views/pmo/pages/InvoiceEdit")),
	},
	{
		key: "pmo-invoice-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/invoice/detail/:id`,
		component: React.lazy(() => import("views/app-views/pmo/pages/InvoiceDetail")),
	},
	{
		key: "pmo-release-form",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/project/:projectId/release/create`,
		component: React.lazy(() => import("views/app-views/pmo/pages/ReleaseFormPage")),
	},
	{
		key: "pmo-release-edit",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/project/:projectId/release/edit/:releaseId`,
		component: React.lazy(() => import("views/app-views/pmo/pages/ReleaseFormPage")),
	},
	{
		key: "pmo-cr-form",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/project/:projectId/change-request/create`,
		component: React.lazy(() => import("views/app-views/pmo/pages/ChangeRequestFormPage")),
	},
	{
		key: "pmo-cr-edit",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/project/:projectId/change-request/edit/:changeRequestId`,
		component: React.lazy(() => import("views/app-views/pmo/pages/ChangeRequestFormPage")),
	},
	{
		key: "pmo-all-tasks",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/all-tasks`,
		component: React.lazy(() => import("views/app-views/pmo/pages/AllTaskList")),
	},
	{
		key: "pmo-timelogs",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/timelogs`,
		component: React.lazy(() => import("views/app-views/pmo/pages/Timelogs")),
	},
	{
		key: "pmo-po-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/pmo/po/list`,
		component: React.lazy(() => import("views/app-views/pmo/pages/POList")),
	},	

];
